import React from 'react';
import { Button, Modal } from 'antd';

const ConfirmationModal = ({ children, isCloseClick, onExec, showModal, setShowModal }) => (
  <Modal
    className="confirm-delete"
    open={showModal}
    onOk={() => setShowModal(false)}
    onCancel={(e) => {
      if (isCloseClick) {
        e.stopPropagation();
      }
      setShowModal(false);
    }}
    footer={[
      <Button
        key="submit"
        type="primary"
        onClick={() => {
          onExec();
          setShowModal(false);
        }}
      >
        OK
      </Button>,
      <Button
        key="back"
        onClick={(e) => {
          if (isCloseClick) {
            e.stopPropagation();
          }
          setShowModal(false);
        }}
      >
        Cancel
      </Button>,
    ]}
  >
    {children}
  </Modal>
);

export default ConfirmationModal;
